import React from 'react';
import './OffersPage.css';

import { PageTitle, Heading, Offer } from '../../../components';
import { offers } from '../../../constants';



const OffersPage = () => {  
  return (  
    <>  
      {/* Page Title */}
      <PageTitle title={'Offers'} page={'Offers'} />

      {/* Offers Section */}
      <section className='offers'>

        {/* Section heading */}
        <Heading title={'Special Offers'} subTitle={'Exclusive Deals'} />

        <div className="box-container">
          {offers.map((offer) => (
            <Offer key={offer.id} offer={offer} />
          ))}
        </div>

      </section>
    </>
  );
}

export default OffersPage;